import { createSvg } from '@r1-frontend/ui-react/components/svg/createSvg';

const SearchNormal = (
    {
        strokeWidth = 1.5,
    },
): JSX.Element => {
    return (
        <g id={'guts'}>
            <path
                d='M11.5 21C16.7467 21 21 16.7467 21 11.5C21 6.25329 16.7467 2 11.5 2C6.25329 2 2 6.25329 2 11.5C2 16.7467 6.25329 21 11.5 21Z'
                strokeWidth={strokeWidth}
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M22 22L20 20'
                strokeWidth={strokeWidth}
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </g>
    );
};

export default createSvg(
    SearchNormal,
    'search-normal',
);
